<template>
    <component :is="layout">
        <notifications group="alert" />
        <router-view/>
    </component>
</template>

<script>
export default {
    computed: {
        layout() {
            return `${this.$route.meta.layout || 'default'}-layout`;
        },
    },
};
</script>
